<template>
  <div class="web-root">
    <div class="page-container">
      <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${barHeight}px`">
        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          </template>
        </van-nav-bar>
      </div>
      <iframe v-if="currentDocPath" id="offical-web-iframe" width="100%" height="100%" :src="currentDocPath" frameborder="0" @load="handleLoaded" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDocPath: null,
      vavaPageOrigin: 'https://www.vava.chat',
      docPathMap: {
        echo: '/official_site/echo/index.html',
        joychat: '/official_site/joychat/index.html',
        joyu: '/official_site/joyu/index.html',
        kiko: '/official_site/kiko/index.html',
        vava: 'https://www.vava.chat/index.html',
        vibeo: '/official_site/vibeo/index.html',
        whonow: '/official_site/whonow/index.html',
      },
    }
  },
  methods: {
    initPage() {
      if (!this.packageName || !this.docPathMap[this.packageName]) return

      this.currentDocPath = this.docPathMap[this.packageName]

      this._handleIframeMsg = (e) => {
        if (e.origin !== this.vavaPageOrigin) return

        if (e.data && e.data.type === 'VAVA_START_CHAT') {
          window.location.replace(e.data.url || this.vavaPageOrigin)
        }
      }

      window.addEventListener('message', this._handleIframeMsg)
    },
    handleLoaded() {
      try {
        // 设置facebook-domain-verification
        const iframeEle = document.getElementById('offical-web-iframe')

        if (iframeEle && iframeEle.contentWindow) {
          const metaTag = iframeEle.contentWindow.document.querySelector('meta[name="facebook-domain-verification"]')

          if (metaTag) {
            const verificationCode = metaTag.getAttribute('content')

            const meta = document.createElement('meta')

            meta.name = 'facebook-domain-verification'

            meta.content = verificationCode

            document.head.appendChild(meta)
          }
        }
      } catch (error) {
        console.log('try catch error:', error)
      }
    },
  },
  mounted() {
    this.initPage()
  },
  beforeDestroy() {
    window.removeEventListener('message', this._handleIframeMsg)
  },
}
</script>

<style lang="scss" scoped>
.web-root {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .page-container {
    box-sizing: border-box;
    background-color: #000000;
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
